export default "__VITE_ASSET__BjxpTWLC__"